import { useEffect } from 'react';
import { useSearchParams } from 'react-router';
import { useAnalyticsContext } from 'src/common/metrics';
export const MissingAuthPage = () => {
    const rumClient = useAnalyticsContext();
    const [searchParams] = useSearchParams();
    useEffect(() => {
        rumClient.recordEvent('MISSING_AUTH_PAGE_LOADED', {});
        // TODO: This is temporary behavior due to the fact that the new domain isn't supported
        // on 100% of devices due to SMA client adoption. We should add a redirect to Amazon
        // page here eventually when we decide to deprecate Painter 1.0.
        // Redirect to web.shop-external.amazon with current path and dexp parameter
        const url = new URL('https://web.shop-external.amazon');
        url.pathname = window.location.pathname; // Retain current path
        const params = new URLSearchParams(searchParams);
        params.set('dexp', 'missingAuthIn20');
        params.set('fallbackFromPainter20', 'true');
        params.set('fallbackReason', 'missing_auth');
        url.search = params.toString();
        window.location.href = url.toString();
    }, [rumClient, searchParams]);
    // Show nothing during redirect (instant redirect)
    return null;
};
